<span (click)="handleCopiarTexto()" (mouseover)="iconCopy = true" (mouseleave)="iconCopy = false">{{texto}}</span> <i class="fas fa-copy" *ngIf="iconCopy"></i>